import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import './multichain.scss';
import Marqueelow from './Marqueelow';
const Multichain = () => {
  const marqueeInnerRef = useRef();

useEffect(() => {
  const marqueeInner = marqueeInnerRef.current;

  const startAnimation = () => {
    requestAnimationFrame(() => {
      const totalWidth = marqueeInner.offsetWidth / 2;

      gsap.fromTo(
        marqueeInner,
        { x: 0 },
        {
          x: -totalWidth,
          duration: 20,
          ease: 'linear',
          repeat: -1,
        }
      );
    });
  };

  const images = marqueeInner.querySelectorAll('img');
  let loaded = 0;

  images.forEach((img) => {
    if (img.complete) {
      loaded++;
    } else {
      img.onload = () => {
        loaded++;
        if (loaded === images.length) startAnimation();
      };
    }
  });

  if (loaded === images.length) startAnimation();
}, []);


    return (
        <section className='main_multichain' id='overview'>
            <div className='inner_multichain'>
                <div className='inner_text'>
                    <h2>
                        <span>Seamless Multichain </span>
                        Deposits and Withdrawals
                    </h2>
                    <p>Aqua Bridge allows you to accept deposits and process withdrawals from all major blockchains — including BTC, ETH, SOL, XRP, ADA, and every major EVM chain.</p>
                    <p>We handle everything in the background so your dApp gets exactly what it needs, automatically.</p>
                </div>
                <div className='marque_siide'>
                    <div className="trendinganimations">
                        <div className="trendinganimationsright">
                             <div className="marquee">
      <div className="marquee__inner" ref={marqueeInnerRef}>
        <div className="marquee__group">
          <img className="imgunder" src="/assets/eth.svg" />
          <img className="imgunder" src="/assets/ava.png" />
          <img className="imgunder" src="/assets/bnb.svg" />
          <img className="imgunder" src="/assets/sol.svg" />
          <img className="imgunder" src="/assets/btc.svg" />
          <img className="imgunder" src="/assets/poly.svg" />
                   <img className="imgunder" src="/assets/eth.svg" />
          <img className="imgunder" src="/assets/ava.png" />
          <img className="imgunder" src="/assets/bnb.svg" />
          <img className="imgunder" src="/assets/sol.svg" />
          <img className="imgunder" src="/assets/btc.svg" />
          <img className="imgunder" src="/assets/poly.svg" />
        </div>
        <div className="marquee__group">
          <img className="imgunder" src="/assets/eth.svg" />
          <img className="imgunder" src="/assets/ava.png" />
          <img className="imgunder" src="/assets/bnb.svg" />
          <img className="imgunder" src="/assets/sol.svg" />
          <img className="imgunder" src="/assets/btc.svg" />
          <img className="imgunder" src="/assets/poly.svg" />
                 <img className="imgunder" src="/assets/eth.svg" />
          <img className="imgunder" src="/assets/ava.png" />
          <img className="imgunder" src="/assets/bnb.svg" />
          <img className="imgunder" src="/assets/sol.svg" />
          <img className="imgunder" src="/assets/btc.svg" />
          <img className="imgunder" src="/assets/poly.svg" />
        </div>
      </div>
    </div>
                        </div>
                    </div>
                    <div className="trendinganimations second_line">
                        <div className="trendinganimationsright">
                        <Marqueelow />
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}

export default Multichain
